import { MediaQuery } from 'shared-ui';
import styled from 'styled-components';

export const LicenseWrapper = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const LicenseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: ${MediaQuery.MEDIUM}px) {
    flex-direction: row;
    gap: 40px;
  }
`;

export const LicenseColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;
